import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import * as keyFrames from "./keyframes";
const Wrapper = styled.div`
  width: 48px;
  height: 48px;
`;
const Svg = styled.svg`
  width: 100%;
  height: 100%;
  animation: ${keyFrames.rotate} 2s linear infinite;
`;
const Circle = styled.circle`
  fill: none;
  stroke: #212121;
  stroke-dasharray: 1.25, 250;
  stroke-dashoffset: 0;
  stroke-linecap: round;
  stroke-miterlimit: 20;
  stroke-width: 4;
  stroke-dasharray: ${keyFrames.scaleRatio * 1}, ${keyFrames.scaleRatio * 200};
  stroke-dashoffset: 0;
  transition: stroke-dasharray 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  animation: ${keyFrames.dashed} 1.5s ease-in-out infinite;
`;
const Circular = (props)=>{
    const { className  } = props;
    return /*#__PURE__*/ _jsx(Wrapper, {
        className: className,
        children: /*#__PURE__*/ _jsx(Svg, {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 60 60",
            children: /*#__PURE__*/ _jsx(Circle, {
                cx: "30",
                cy: "30",
                r: "25"
            })
        })
    });
};
export default Circular;
